import { z } from "zod/v4";

import {
  StripeApiPriceTemplateDtoSchema,
  StripePriceMetadataSchema,
  StripeSubscriptionIntervalList,
} from "../../schemas/stripe";
import { castToNumberOrBoolean } from "../../utils";
import { StripeIntervalList, SubscriptionIntervalList } from "../subscriptions";

import { StripeApiProductDtoSchema } from "./product";

export const ParsedStripeFeatureMetadataSchema = z.object({
  key: z.string(),
  value: castToNumberOrBoolean,
});

export type ParsedStripeFeatureMetadata = z.infer<
  typeof ParsedStripeFeatureMetadataSchema
>;

export const StripeProductFeatureMetadataDtoSchema = z.object({
  key: z.string(),
  value: z.string(),
});

export type StripeEntitlementFeatureMetadata = z.infer<
  typeof StripeProductFeatureMetadataDtoSchema
>;

export const StripeApiProductFeatureDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  metadata: ParsedStripeFeatureMetadataSchema,
});

export type StripeApiProductFeatureDto = z.infer<
  typeof StripeApiProductFeatureDtoSchema
>;

export const StripeApiPriceTierDtoSchema = z.object({
  flatAmount: z.number().nullish(),
  unitAmount: z.number().nullish(),
  upTo: z.number().nullish(),
  description: z.string().nullish(),
});

export type StripeApiPriceTierDto = z.infer<typeof StripeApiPriceTierDtoSchema>;

export const StripeApiPriceDtoSchema = z.object({
  id: z.string(),
  active: z.boolean().nullish(),
  name: z.string(),
  meterId: z.string().nullish(),
  currency: z.string(),
  unitAmount: z.number().nullish(),
  tiers: StripeApiPriceTierDtoSchema.array(),
  tiersMode: z.enum(["graduated", "volume"]).nullish(),
  interval: z.enum(StripeIntervalList).nullish(),
  intervalCount: z.number().nullish(),
  templates: StripeApiPriceTemplateDtoSchema.array(),
  tier: z.string().nullish(),
  metadata: StripePriceMetadataSchema.nullish(),
});

export type StripeApiPriceDto = z.infer<typeof StripeApiPriceDtoSchema>;

export const SubscriptionProductDtoSchema = StripeApiProductDtoSchema.extend({
  displayPrice: z.number(),
  interval: z.enum(StripeSubscriptionIntervalList),
});

export type SubscriptionProductDto = z.infer<
  typeof SubscriptionProductDtoSchema
>;
